import {Injectable} from '@angular/core';


@Injectable({
  providedIn: 'root'
})

export class ProjectDetailTabService {
  tabIndex = 0;
  propertyIndex = 0;
  lotIndex = 0;
  eoiIndex = 0;
  agencyIndex = 0;

  constructor() {
  }

  reset() {
    this.tabIndex = 0;
    this.propertyIndex = 0;
    this.lotIndex = 0;
    this.eoiIndex = 0;
    this.agencyIndex = 0;
  }

}
